
import { Delivery, DeliveryStage } from '@/types/delivery';
import { getProjectType, getPriority } from './delivery-utils';

// Define common properties to reuse
type BaseDeliveryFields = {
  progress: number;
  team: string[];
};

// Create a factory function to generate delivery items
export const createDeliveryItem = (
  id: string,
  name: string,
  description: string,
  companyName: string,
  contact: string,
  status: DeliveryStage,
  dueDate: string,
  fields: Partial<BaseDeliveryFields> = {}
): Delivery => {
  return {
    id,
    title: name,
    description,
    status,
    dueDate,
    assignee: contact,
    priority: getPriority(status),
    type: getProjectType(status),
    stage: status,
    company: {
      name: companyName
    },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    tags: []
  };
};
